__turbopack_context__.v({
  "root": "SleepStagesModal-module__InVJoq__root",
});
